// Total number of users (millions)

// Reference links: 
// https://developer.github.com/v4/explorer/ | https://github.com/about
// https://meta.stackexchange.com/a/243392 

export const TOTAL_GITHUB_USERS = 73
export const TOTAL_STACKOVERFLOW_USERS = 14
